import { Link } from 'react-router-dom';
import AuthShell from '../../components/auth/AuthShell';

export default function ForgotUsername() {
  return (
    <AuthShell
      title="Forgot username"
      subtitle="Your username is your email."
      footer={
        <span>
          Still stuck? Contact <a href="mailto:admin@oculusmind.ai">admin@oculusmind.ai</a>.
        </span>
      }
    >
      <p>
        OculusMind.AI uses your email as your username. If you remember any
        email you might have used, try{' '}
        <Link to="/auth/forgot-password">Forgot password</Link> &mdash; we'll only
        send a code if there's an account.
      </p>
    </AuthShell>
  );
}
